import {HttpClient} from '@angular/common/http';
import { computed, Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {MessageHandlerService} from './messageHandler.service';
import {environment} from '../../../environments/environment';
import {CurrentUserService} from './current-user.service';

const UPDATE_DATE = `${environment.baseUrl}/users/customer/updateDateFormat`;
export const DEFAULT_DATE_FORMAT = 'eu-EU';


@Injectable({
  providedIn: 'root',
})
export class DateFormatService {
  private readonly messageService = inject(MessageHandlerService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly http = inject(HttpClient);

  public dateFormats: DateFormat[] = [
    {name: 'European', tag: 'eu-EU', format: 'dd/MM/yyyy, HH:mm:ss'},
    {name: 'English-US', tag: 'en-US', format: 'yyyy/MM/dd, h:mm:ss a'},
    {name: 'Japanese', tag: 'ja-JP', format: 'yyyy/MM/dd, HH:mm:ss'},
  ];

  public userDateFormat$ = computed(() => {
    return this.dateFormats
        .find((format) => this.currentUserService.currentUser$().dateFormat === format.tag)
      ?? this.dateFormats[0];
  });

  updateDateFormat(dateFormat: string): Observable<any> {
    return this.http.put<any>(`${UPDATE_DATE}/${dateFormat}`, undefined).pipe(
      tap(() => {
        this.currentUserService.updateCurrentUser({dateFormat});
        this.messageService.log(
          'Validation',
          `The date format has been updated`,
          1
        );
      }),
      catchError(this.messageService.handleError<any>('update date format'))
    );
  }
}

export interface DateFormat {
  name: string;
  tag: string;
  format: string;
}
